import { createSelector } from "@reduxjs/toolkit";

export const socialCollaborationPortalEnabledSelector = createSelector<[(state: LSStore.State) => LSCommon.BrandedJsModel | null], boolean>(state => state.branding.value, branding => branding?.socialCollaborationPortalEnabled ?? false);
